import { INIT_FILTER_STATE } from "components/styled/filter/Filter.constants";
import { atom } from "jotai";
import type { PatientsFilters, PatientsFilterSettings, PatientsSortSettings } from "pages/Patients";

/** PIPCARE-1358: the last Patients view (query string), so links back to the list restore it. */
export const patientsLastQueryAtom = atom<string>("");
export const patientsFilterSettingsAtom = atom<PatientsFilterSettings | null>(null);
export const patientsSortingSettings = atom<PatientsSortSettings>(["-enrolled_date"]);
export const patientsFilters = atom<PatientsFilters>(INIT_FILTER_STATE);
